import React from 'react';
import { QueryClientProvider } from 'react-query';
import { Link } from 'react-router';
import { css } from '@emotion/react';
import SiteSVG from '@birdi/icons/sites-globe.svg';
import {
  SidebarLink,
  TitleHolder,
  TitleStyle,
  iconStyle,
} from '../common/side-menu/side-bar-utils';
import { mapSitesQueryClient, useSitesList } from './queries';

const SitesLinks = ({ pathname }: { pathname: string }) => {
  const { data: sites } = useSitesList();
  return (
    <>
      {(sites ?? []).map((site) => (
        <SidebarLink
          key={site.id}
          to={`/sites/${site.id}`}
          match={pathname}
          dashboard
        >
          <span
            css={css`
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            `}
          >
            {site.name}
          </span>
        </SidebarLink>
      ))}
    </>
  );
};

/**
 * The flag-gated Sites section of the dashboard sidebar: a "Sites" title row
 * linking to /sites, then one link per site. Shares the Map Sites query
 * client so the list is cached with the All Sites page.
 */
export const SidebarSitesSection = ({ pathname }: { pathname: string }) => (
  <QueryClientProvider client={mapSitesQueryClient}>
    <Link
      to="/sites"
      data-testid="sites-nav-link"
      css={css`
        display: block;
        text-decoration: none;
        outline: none;
        &:focus,
        &:focus-visible {
          outline: none;
          box-shadow: none;
        }
      `}
    >
      <div
        css={(theme) => css`
          ${TitleHolder};
          color: ${theme.midnight};
          border-radius: 7px;
          background-color: ${pathname === '/sites'
            ? theme.lightOcean
            : theme.mono0};
          &:hover {
            background-color: ${pathname !== '/sites'
              ? theme.sand
              : theme.lightOcean};
          }
        `}
      >
        <span
          css={css`
            ${iconStyle};
            display: inline-flex;
            svg {
              width: 100%;
              height: 100%;
            }
          `}
        >
          <SiteSVG />
        </span>
        <span css={TitleStyle}>Sites</span>
      </div>
    </Link>
    <SitesLinks pathname={pathname} />
  </QueryClientProvider>
);
